<template>
  <div>
    <privacyPolicy :productName="'格力云派工'"></privacyPolicy>
  </div>
</template>

<script>
import privacyPolicy from '@/views/privacyPolicy/privacyPolicy.vue';
export default {
    components:{
        privacyPolicy
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/privacyPolicy/cloudDispatchPrivacyPolicy.vue